"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const CursorTwoBoxes = createSVGIcon(
  <>
    <path
      d="M22.52 30.5H1.5c-.55 0-1-.45-1-1v-1.94c0-.55.45-1 1-1h21.02c.55 0 1 .45 1 1v1.94c0 .55-.44 1-1 1Z"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x=".5"
      y=".5"
      width="23"
      height="22"
      rx="1.5"
      fill="none"
      stroke="currentColor"
    />
    <path
      d="M27.599 13.941a.5.5 0 0 0-.053-.824l-6.94-4.124a.5.5 0 0 0-.746.529l1.656 8.257a.5.5 0 0 0 .799.295l1.575-1.235 1.4 2a.5.5 0 0 0 .715.11l1.303-1.01a.5.5 0 0 0 .102-.683l-1.437-2.044z"
      fill="#fff"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CursorTwoBoxes",
  { viewBox: "0 0 29 31", titleAccess: "CursorTwoBoxes" }
);
